export const GRID_SIZE = 10;

export interface Position { row: number; col: number; }
export type Direction = "h" | "v";

export interface ShipDef { name: string; size: number; }

export const SHIPS: ShipDef[] = [
  { name: "Carrier", size: 5 },
  { name: "Battleship", size: 4 },
  { name: "Cruiser", size: 3 },
  { name: "Submarine", size: 3 },
  { name: "Destroyer", size: 2 },
];

export interface Ship { name: string; size: number; positions: Position[]; hits: boolean[]; }
export type CellState = "empty" | "ship";
export type AttackResult = "unknown" | "hit" | "miss";

export interface PlayerBoard {
  grid: CellState[][];
  attackGrid: AttackResult[][];
  ships: Ship[];
}

export interface BSPlayer { name: string; board: PlayerBoard; isCPU: boolean; }
export type Phase = "placement" | "playing" | "finished";

export interface BattleshipGame {
  phase: Phase;
  players: [BSPlayer, BSPlayer];
  turn: 0 | 1;
  winner: number | null;
  placementShip: number;
}
